
import React from 'react';
import { AlertCircle } from 'lucide-react';

interface GeneralErrorProps {
  error: string;
}

const GeneralError = ({ error }: GeneralErrorProps) => {
  if (!error) return null;
  
  return (
    <div className="p-3 text-sm border border-red-300 bg-red-50 text-red-600 rounded-md flex items-start">
      <AlertCircle size={16} className="mr-2 mt-0.5 flex-shrink-0" />
      <span>{error}</span>
    </div>
  );
};

export default GeneralError;
